export const addQueryParam = (
  query: string,
  name: string,
  value: number | string | undefined
): string => {
  if (value && ((name === "page" && value === 0) || value !== 0)) {
    return `${query}&${name}=${value}`;
  } else {
    return query;
  }
};
